export enum EEventHistoryMenuKey {
  Notes = 'notes',
  EventHistory = 'event_history',
  All = 'all',
}

export enum EHistoryType {
  received = 'received',
  moved_back = 'moved_back',
  completed = 'completed',
  call = 'call',
  spentTimeRecordAdded = 'spentTimeRecordAdded',
  spentTimeRecordEdited = 'spentTimeRecordEdited',
  commentIsLeft = 'commentIsLeft',
  spentTimeCancelled = 'spentTimeCancelled',
  review = 'review',
  release = 'release',
  escalated = 'escalated',
}

export enum EHistoryTypeLabel {
  received = 'Incoming event item for review',
  moved_back = 'Moved back to Inbox',
  completed = 'Event is completed',
  call = 'Call to the patient',
  spentTimeRecordAdded = 'Time spent',
  spentTimeRecordEdited = 'Time edited',
  commentIsLeft = 'A comment is left',
  spentTimeCancelled = 'Time deleted',
  review = 'Review',
  release = 'Released from hold',
  escalated = 'Event is escalated',
}
